import { useEffect, useState } from 'react'
import { mrbgStore } from './mrbg/mrbgRedux/index.js'
import { mrbgTools } from '../mrbgLib/mrbgTools.js'

function SetOperator(){

  const
    [formID,setFormID] = useState(undefined),
    [activeForms,setActiveForms] = useState(mrbgStore.getState().activeForms),
    [formSettings,setFormSettings] = useState( {} );

  useEffect(()=>{
    if( activeForms?.includes('apoSesActFrame') )
      setFormID('apoSesAct');
    else
      setFormID(undefined)
  },[activeForms])
  useEffect(() => {
    if( formID ){
      setFormSettings(mrbgStore.getState().formsSettings[formID]);
      const unsubscribe = mrbgStore.subscribe(()=>{
        setFormSettings(mrbgStore.getState().formsSettings[formID])
      })
      return () =>unsubscribe();
    }
  }, [formID]);
  useEffect(()=>{
    var
      fs = {...formSettings};

    if( formID && fs.sundryField && fs.sundryField.operator ){
      var val = fs.sundryField.operator[0];
      document.getElementByDataID(formID).querySelectorAll('input[name^="operator["]').forEach(elm=> {
        if( elm.getAttribute('name')=='operator[0]' )
          return;
        if( elm.value.trim()==='' || elm.value.trim()==val.substring(0,val.length-1) || elm.value.trim().substring(0,elm.value.trim().length-1)==val )
          mrbgTools.triggerChange( elm,val );
      })
    }
  },[formID,formSettings?.sundryField])
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setActiveForms( mrbgStore.getState().activeForms );
    })
    return () =>unsubscribe();
  },[]);

  return '';
}
export default SetOperator;